import { render } from "./ComCard.vue?vue&type=template&id=102e71be&ts=true"
import script from "./ComCard.vue?vue&type=script&lang=ts"
export * from "./ComCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__